import React, { useState, useEffect } from "react";
import { ReptoolModal } from "../../utilities/ReptoolModal.tsx";
import { ReptileTile } from "../../utilities/ReptileTile.tsx";
import { FindMorphByGenes } from "../../utilities/FindMorph.ts";
import { Morph } from "../../../types/Morph.ts";
import { CollectionReptile } from "../../collection/types/CollectionTypes.ts";
import { Clutch } from "../../../types/Clutch.ts";
import { useRepToolContext } from "../../../RepToolContext.tsx";

const SelectedReptile = ({ reptile, morphs }: {
  reptile: CollectionReptile;
  morphs: Morph[]

}) => {
  const morph = FindMorphByGenes(reptile.genes, morphs);
  const picture = reptile.picture || morph?.pictures?.[0].url || "images/notavailable.jpg";
  return (
    <div className="border rounded flex-fill">
      <img src={picture} width='100%' />
      <div>
        <small>{picture === morph?.pictures?.[0]?.url && morph?.pictures?.[0]?.credit}</small>
      </div>
      <h6>{reptile.name || reptile.morph_name}</h6>
    </div>
  )

}

export const ClutchReptileModal = ({
  closeModal,
  editingClutch,
  morphs
}: {
  closeModal: () => void;
  editingClutch: Clutch;
  morphs: Morph[]
}) => {
  const { appendControls } = useRepToolContext();
  useEffect(() => {
    appendControls(null, "Reptiles Produced Modal")
  }, []);
  return (
    <>
      <ReptoolModal id='create-clutch-modal' title="Reptiles Produced" closeModal={closeModal} body={
        <div className="d-flex flex-column mb-5">
          <div className="d-flex flex-row justify-content-around">
            <div className="text-center col-4 ">
              <h5>Sire:</h5>
              <div>
                <SelectedReptile reptile={editingClutch?.father} morphs={morphs} />
              </div>
            </div>
            <div className="text-center col-4 ">
              <h5>Dam:</h5>
              <div>
                <SelectedReptile reptile={editingClutch?.mother} morphs={morphs} />
              </div>
            </div>
          </div>
          <hr />
          <div className="d-flex flex-wrap">
            {
              editingClutch.produced_reptiles.map((reptile, x) => {
                const morph = FindMorphByGenes(reptile.genes, morphs)
                return (
                  <ReptileTile
                    key={x}
                    reptile={reptile}
                    hideButton
                    morphInfo={morph || null}
                  />
                )
              })
            }
          </div>
        </div>
      } />
    </>

  )
}
